import type { Car, FindAllCarsQueryDto, UpdateCarDto } from '@/entities/cars/car.entity';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import { Service } from './http-service';
import type {
  CarsControllerGetCarMilageExpectationData,
  MilageExpectationResponseDto,
  RegistrationCertificateExtractionDto,
} from '@carvia/ros-client-types';

class CarsService extends Service<Car, FindAllCarsQueryDto, UpdateCarDto> {
  constructor() {
    super('/cars');
  }

  async getAllWithQuery(params: FindAllCarsQueryDto) {
    const res = await this.httpClient.get<PaginatedResponse<Car>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }

  async extractRegistrationCertificate(
    carId: string,
  ): Promise<RegistrationCertificateExtractionDto> {
    const res = await this.httpClient.post<RegistrationCertificateExtractionDto>(
      `${this.endpoint}/${carId}/extract-registration-certificate`,
    );
    return res.data;
  }

  async getMilageExpectation(
    carId: string,
    params: CarsControllerGetCarMilageExpectationData['query'],
  ): Promise<MilageExpectationResponseDto> {
    const res = await this.httpClient.get<MilageExpectationResponseDto>(
      `${this.endpoint}/${carId}/milage-expectation`,
      { params },
    );
    return res.data;
  }
}

export const carsService = new CarsService();
